import React, { useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ImagePlusIcon, ShapesIcon, TypeIcon } from "lucide-react";
import { cliparts } from "../../data/designAssets";
interface AddElementBarProps {
  zoneName: string;
  showCliparts: boolean;
  uploadError: string | null;
  provideLater: boolean;
  onFile: (file: File) => void;
  onAddText: () => void;
  onToggleCliparts: () => void;
  onAddClipart: (id: string) => void;
  onSampleLogo: () => void;
  onProvideLater: (value: boolean) => void;
}
export function AddElementBar({
  zoneName,
  showCliparts,
  uploadError,
  provideLater,
  onFile,
  onAddText,
  onToggleCliparts,
  onAddClipart,
  onSampleLogo,
  onProvideLater
}: AddElementBarProps) {
  const fileRef = useRef<HTMLInputElement>(null);
  const secondary = "flex items-center justify-center gap-2 whitespace-nowrap border border-ink px-4 py-3 text-sm font-bold transition-colors duration-150 ease-out hover:bg-mist";
  return <div className="border-t border-line p-4 md:p-5" data-id="element-230" data-mp="2gw1d0nqx7pmc">
      <p className="mb-3 text-xs text-muted" data-id="element-231" data-mp="2guggisl1pwlu">
        Ajouter sur <span className="font-bold text-ink" data-id="element-232" data-mp="2bxgauis3yvv9">{zoneName}</span>
      </p>
      <div className="grid gap-2 sm:grid-cols-[1.3fr_1fr_1fr]" data-id="element-233" data-mp="2bzasno8327v4">
        <button type="button" onClick={() => fileRef.current?.click()} className="flex items-center justify-center gap-2 whitespace-nowrap bg-ink px-4 py-3 text-sm font-bold text-paper transition-colors duration-150 ease-out hover:bg-cherry" data-id="element-234" data-mp="2pw66dtza4nhi">
          <ImagePlusIcon size={18} aria-hidden="true" data-id="element-235" data-mp="1t7i1lzckqwq1" />
          Importer mon logo
        </button>
        <button type="button" onClick={onAddText} className={secondary} data-id="element-236" data-mp="26yvgv13g98f9">
          <TypeIcon size={18} aria-hidden="true" data-id="element-237" data-mp="226ln19z7ro7p" />
          Ajouter un texte
        </button>
        <button type="button" onClick={onToggleCliparts} aria-expanded={showCliparts} className={`${secondary} ${showCliparts ? "bg-mint hover:bg-mint" : ""}`} data-id="element-238" data-mp="1ehaq63kzidyu">
          <ShapesIcon size={18} aria-hidden="true" data-id="element-239" data-mp="1aduyzmrop5tj" />
          Pictogramme
        </button>
      </div>
      <input ref={fileRef} type="file" accept="image/png,image/svg+xml,image/jpeg" className="sr-only" tabIndex={-1} onChange={e => {
      const file = e.target.files?.[0];
      if (file) onFile(file);
      e.target.value = "";
    }} data-id="element-240" data-mp="39imlvpq166lk" />

      <AnimatePresence initial={false} data-id="element-241" data-mp="3obg61og8zawk">
        {showCliparts && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: "auto"
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-242" data-mp="2qneg4z4rfofl">
            <ul className="mt-3 grid grid-cols-6 border-l border-t border-line" data-id="element-243" data-mp="35koxuq7zxqjr">
              {cliparts.map(c => {
            const Icon = c.icon;
            return <li key={c.id} className="border-b border-r border-line" data-id="element-244" data-mp="krtwn5q1tgz1">
                    <button type="button" onClick={() => onAddClipart(c.id)} aria-label={`Ajouter le pictogramme ${c.name}`} title={c.name} className="flex aspect-square w-full items-center justify-center transition-colors duration-150 ease-out hover:bg-rose" data-id="element-245" data-mp="25bfeijq4tokz">
                      <Icon size={22} aria-hidden="true" data-id="element-246" data-mp="1lmogqmg1ds0w" />
                    </button>
                  </li>;
          })}
            </ul>
          </motion.div>}
      </AnimatePresence>

      {uploadError && <p role="alert" className="mt-3 text-sm font-bold text-cherry" data-id="element-247" data-mp="1cn1k0dy95ae6">
          {uploadError}
        </p>}

      <div className="mt-4 flex flex-wrap items-center justify-between gap-3" data-id="element-248" data-mp="17ozwngtsmoww">
        <p className="text-xs text-muted" data-id="element-249" data-mp="36yyfchztf0ei">PNG, SVG ou JPEG · 20 Mo max · glisser-déposer accepté</p>
        <button type="button" onClick={onSampleLogo} className="text-xs font-bold underline underline-offset-4 hover:text-cherry" data-id="element-250" data-mp="322hohg18e7xq">
          Essayer avec un logo exemple
        </button>
      </div>
      <label className="mt-4 flex cursor-pointer items-center gap-3 text-sm" data-id="element-251" data-mp="23o2gsdf0hycq">
        <input type="checkbox" checked={provideLater} onChange={e => onProvideLater(e.target.checked)} className="h-4 w-4 accent-ink" data-id="element-252" data-mp="1pqdsevlqk92x" />
        Je fournirai mon fichier plus tard
      </label>
    </div>;
}